import { Button, Classes, Dialog, Intent } from '@blueprintjs/core';
import styled from '@emotion/styled';
import * as React from 'react';
import { TLCode } from '../../common/enums';
import { TranslatedMessage } from '../common/translation';

interface AddUserDefinedCircleDialogProps {
  isOpen: boolean;
  onClose: () => void;
  circleLat: number;
  circleLng: number;
  onCircleAdd: (lat: number, lng: number, radius: number) => void;
}

export const AddUserDefinedCircleDialog = ({
  isOpen,
  onClose,
  circleLat,
  circleLng,
  onCircleAdd,
}: AddUserDefinedCircleDialogProps) => {
  const [radius, setRadius] = React.useState(undefined as number | undefined);

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={<TranslatedMessage id={TLCode.TRANSFER_AddCircleDialogTitle} />}
      style={{ width: '580px' }}
      canOutsideClickClose={false}
    >
      <div className={Classes.DIALOG_BODY}>
        <DivLine style={{ marginTop: '20px' }}>
          <TranslatedMessage id={TLCode.TRANSFER_Radius} />
          &nbsp;&nbsp;
          <Button intent={Intent.NONE} text={'100m'} onClick={() => setRadius(100)} />
          <Button intent={Intent.NONE} text={'500m'} onClick={() => setRadius(500)} />
          <Button intent={Intent.NONE} text={'1000m'} onClick={() => setRadius(1000)} />
          <Button intent={Intent.NONE} text={'1500m'} onClick={() => setRadius(1500)} />
          <Button intent={Intent.NONE} text={'3000m'} onClick={() => setRadius(3000)} />
        </DivLine>
        <DivLine style={{ marginTop: '20px' }}>
          <TranslatedMessage id={TLCode.TRANSFER_SelectedLat} />
          &nbsp;&nbsp;{Math.round(circleLat * 1000) / 1000}
        </DivLine>
        <DivLine style={{ marginTop: '20px' }}>
          <TranslatedMessage id={TLCode.TRANSFER_SelectedLng} />
          &nbsp;&nbsp; {Math.round(circleLng * 1000) / 1000}
        </DivLine>
        <DivLine style={{ marginTop: '20px' }}>
          <TranslatedMessage id={TLCode.TRANSFER_SelectedRadius} />
          &nbsp;&nbsp;{radius + ' (m)'}
        </DivLine>
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button
            intent={Intent.PRIMARY}
            disabled={radius === undefined}
            onClick={() => {
              onCircleAdd(circleLat, circleLng, radius!);
              onClose();
            }}
            text={<TranslatedMessage id={TLCode.GENERAL_Add} />}
          />
        </div>
      </div>
    </Dialog>
  );
};

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;
